<template>
    <div class="n2-container">
        <div class="n2-nav-back">
            <a @click="$router.go(-1)" class="n2-link-back">
                <div style="display: flex; align-items:center;">
                    <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                    <span style="margin-left:5px;">
                        {{ $t('pages.admin.roles.back') }}
                    </span>
                </div>
            </a>
        </div>
        <div class="n2-page-title">
            <h3>{{ $t('pages.admin.roles.title') }}</h3>
        </div>
        <p>
            <router-link class="n2-link-1" v-bind:to="`/${app_locale}/admin/roles/new`">
                {{ $t('pages.admin.roles.create') }}
            </router-link>
        </p>
        <div class="n2-row-padding">
            <div class="col-md-3">
                <label>{{ $t('pages.admin.roles.search_by_name') }}</label>
                <input v-model="query.name" type="text" class="n2-input-default" />
            </div>
        </div>
        <div style="margin:10px 0 20px;">
            <pager v-on:page-changed="navToPage($event)" v-bind:page_number="query.page_number"
                v-bind:page_size="query.page_size" v-bind:total_size="total_size"></pager>
        </div>
        <div style="position:relative;">
            <div v-if="entities.length > 0" class="n2-grid-0" v-bind:style="{ 'grid-template-columns': grid_columns }">
                <template v-for="col in columns">
                    <div v-if="col == 'name'" class="n2-grid-cell n2-grid-header" v-bind:key="col">
                        <a v-on:click="sort('name')">
                            {{ $t('pages.admin.roles.name') }}
                            <template v-if="sortings.name === 1">
                                &#9650;
                            </template>
                            <template v-if="sortings.name === 2">
                                &#9660;
                            </template>
                        </a>
                    </div>
                    <div v-if="col == 'claims'" class="n2-grid-cell n2-grid-header" v-bind:key="col">
                    </div>
                </template>

                <template v-for="(entity) in entities">
                    <template v-for="col in columns" v-bind:key="entity.id">
                        <div v-if="col == 'name'" class="n2-grid-cell" v-bind:key="col">
                            <a v-bind:href="`/${app_locale}/admin/roles/${entity.id}`">
                                {{ entity.name }}
                            </a>
                        </div>
                        <div v-if="col == 'claims'" class="n2-grid-cell">
                            <a v-bind:href="`/${app_locale}/admin/roles/${entity.id}/claims`">
                                {{ $t('pages.admin.roles.claims') }}
                            </a>
                        </div>
                    </template>
                </template>
            </div>
            <div v-else class="title-default">
                {{ $t('shared.pager.no_record') }}
            </div>
        </div>
        <div style="margin:20px 0;">
            <pager v-on:page-changed="navToPage($event)" v-bind:page_number="query.page_number"
                v-bind:page_size="query.page_size" v-bind:total_size="total_size"></pager>
        </div>

        <app-loader v-bind:active="loading"></app-loader>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { debounce } from '../shared';
import { RoleService } from '../services';
import Pager from '../components/shared/pager.vue';
import AppLoader from '../components/shared/loader.vue'

export default {
    components: {
        Pager, AppLoader
    },
    props: {
    },
    data: function () {
        return {
            query: {
                page_size: 100,
                page_number: 1,
                sort_by: '',
                sort_direction: '',
                name: '',
            },
            total_size: 0,
            sortings: {
                name: 0
            },
            entities: [],
            error: '',
            loading: false,
            columns: ['name', 'claims'],
        }
    },
    computed: {
        ...mapGetters('globalization', [
            'locale', 'app_locale'
        ]),
        grid_columns_length: function () {
            let len = this.columns.length + 1;
            return len;
        },
        grid_columns: function () {
            return new Array(this.grid_columns_length).join('auto ');
        },
    },
    watch: {
        // whenever question changes, this function will run
        'query.name': function () {
            this.debouncedSearch();
        },
        'query.sort_by': function () {
            this.debouncedSearch();
        },
        'query.sort_direction': function () {
            this.debouncedSearch();
        }
    },
    created: function () {
        this.currentService = new RoleService();
        this.debouncedSearch = debounce(this.nav, 500);
    },
    mounted: async function () {
        Object.assign(this.query, this.$route.query);
        await this.search();
    },
    beforeRouteUpdate(to, from, next) {
        Object.assign(this.query, to.query);
        this.search();
        next();
    },
    methods: {
        sort: function (field) {
            this.sortings[field] = (this.sortings[field] + 1) % 3;
            this.query.sort_by = this.sortings[field] === 0 ? '' : field;
            this.query.sort_direction = this.sortings[field] === 0 ? '' : this.sortings[field] === 1 ? 'asc' : 'desc';
            Object.keys(this.sortings).filter(k => { return k !== field; }).forEach(k => this.sortings[k] = 0);
        },
        search: async function () {
            this.loading = true;
            try {
                var response = await this.currentService.search(this.query);
                this.entities = response.data;
                this.total_size = response.total_size;
                this.query.page_size = response.page_size;
                this.query.page_number = response.page_number;
            } catch (e) {
                this.error = e;
            }
            finally {
                this.loading = false;
            }
        },
        nav: function () {
            this.$router.push({
                path: '', query: this.query
            });
        },
        navToPage: function (page_number) {
            this.query.page_number = page_number;
            this.nav();
        }
    },

}
</script>